import { Injectable, OnDestroy, signal } from '@angular/core';

export interface IKartGuncelleme {
  kartId: string;
  veri: any;
  kaynak?: string;
}

export interface ISunucuKartOlayi {
  tip: 'yeni' | 'guncellendi' | 'silindi';
  kartId: string;
  kaynakKid?: string;
}

const KANAL_ADI = 'FikoYT.kart.canli-guncelleme';
const SUNUCU_OLAYI = 'FikoYT.paylasim.kart.degisti';

@Injectable({ providedIn: 'root' })
export class CanliGuncellemeService implements OnDestroy {
  kartGuncellendi = signal<IKartGuncelleme | null>(null);
  kartSilindi = signal<string | null>(null);
  kartYeni = signal<any | null>(null);
  /** Sunucudan (Socket.IO) gelen kart değişiklik olayı — diğer kullanıcı/cihazlar */
  sunucuOlayi = signal<ISunucuKartOlayi | null>(null);

  private kanal: BroadcastChannel | null = null;
  private tabId = Math.random().toString(36).slice(2, 8);
  private socketBagliMi = false;
  private socketSub: { unsubscribe(): void } | null = null;

  constructor() {
    this.kanalBaslat();
  }

  /** Socket.IO istemcisini bağlar (FikoYT.io). Tekrarlı çağrı güvenlidir. */
  socketBagla(io: { fromEvent(olay: string): { subscribe(cb: (v: any) => void): any } } | null | undefined) {
    if (this.socketBagliMi || !io?.fromEvent) return;
    try {
      this.socketSub = io.fromEvent(SUNUCU_OLAYI).subscribe((v: any) => {
        if (!v?.tip || !v?.kartId) return;
        this.sunucuOlayi.set({ tip: v.tip, kartId: v.kartId, kaynakKid: v.kaynakKid });
      });
      this.socketBagliMi = true;
    } catch (e) {
      console.warn('Canlı güncelleme socket bağlantısı kurulamadı', e);
    }
  }

  private kanalBaslat() {
    try {
      this.kanal = new BroadcastChannel(KANAL_ADI);
      this.kanal.onmessage = (e: MessageEvent) => {
        const { tip, veri, kaynak } = e.data || {};
        if (kaynak === this.tabId) return;
        switch (tip) {
          case 'guncellendi':
            this.kartGuncellendi.set({ kartId: veri.kartId, veri: veri.kart, kaynak });
            break;
          case 'silindi':
            this.kartSilindi.set(veri.kartId);
            break;
          case 'yeni':
            this.kartYeni.set(veri.kart);
            break;
        }
      };
    } catch { }
  }

  guncellemeYayin(kartId: string, kart: any) {
    this.kartGuncellendi.set({ kartId, veri: kart });
    this.kanal?.postMessage({ tip: 'guncellendi', veri: { kartId, kart }, kaynak: this.tabId });
  }

  silindiYayin(kartId: string) {
    this.kartSilindi.set(kartId);
    this.kanal?.postMessage({ tip: 'silindi', veri: { kartId }, kaynak: this.tabId });
  }

  yeniYayin(kart: any) {
    this.kartYeni.set(kart);
    this.kanal?.postMessage({ tip: 'yeni', veri: { kart }, kaynak: this.tabId });
  }

  ngOnDestroy() {
    this.kanal?.close();
    this.kanal = null;
    this.socketSub?.unsubscribe();
    this.socketSub = null;
    this.socketBagliMi = false;
  }
}
